/** Medicine specialties → surgical specialty IDs where procedures are stored. */
const FALLBACK_PROCEDURE_SPECIALTY_MAP = {
  18: ["33"],
  19: ["32"],
  20: ["35", "41"],
  23: ["33"],
  44: ["33", "39"],
  45: ["33", "38"],
  46: ["32", "42"],
  47: ["32"],
  49: ["34"],
  50: ["33"],
  53: ["31"],
  54: ["35", "41"],
  57: ["42"],
  59: ["36"],
  60: ["38"],
  62: ["43"],
};

export function resolveProcedureSpecialtyIds(specialtyId, specialty) {
  const id = String(specialtyId ?? "").trim();
  if (!id) return [];

  const fromRecord = specialty?.procedure_specialty_ids?.trim();
  if (fromRecord) {
    return fromRecord
      .split(",")
      .map((value) => value.trim())
      .filter(Boolean);
  }

  if (FALLBACK_PROCEDURE_SPECIALTY_MAP[id]) {
    return FALLBACK_PROCEDURE_SPECIALTY_MAP[id];
  }

  return [id];
}

export function filterProceduresForSpecialty(procedures, specialtyId, specialty) {
  const filterIds = new Set(resolveProcedureSpecialtyIds(specialtyId, specialty));
  if (filterIds.size === 0) return [];

  return procedures.filter((procedure) =>
    filterIds.has(String(procedure.medical_specialty_id))
  );
}
